import { formatNumber } from '@dop/shared/helpers/string';
import { TextSize } from 'victory';
import { fontStyle } from '../../cbsGraph.config';

/**
 * retrieve the inline-size of the tick-labels of the y-axis
 */
export const getLineGraphTickLabelInlineSize = ({
	decimals,
	globalMax,
	globalMin,
}: {
	decimals?: number;
	globalMax?: number;
	globalMin?: number;
}) => {
	if (globalMax == null || globalMin == null || decimals == null) return 0;

	const globalMaxFormatted = formatNumber({ decimals, number: globalMax });
	const globalMinFormatted = formatNumber({ decimals, number: globalMin });

	const { width: tickLabelWidth } = TextSize.approximateTextSize(
		[globalMaxFormatted, globalMinFormatted],
		fontStyle,
	);

	return tickLabelWidth + 10;
};
